import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosDotnet from '../services/axiosDotnet';
import { showSuccess, showError } from '../services/reactToastify';
import Loader from "../Components/Loader";

export default function UpdateWorkspace() {

    const id = useParams().wId;
    const navigate = useNavigate();

    const [workspace, setWorkspace] = useState({ name: '', description: '' });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchWorkspace = async () => {
            try {

                const res = await axiosDotnet.get(`/api/workspaces/${id}`);
                setWorkspace({
                    name: res?.data.name,
                    description: res?.data.description || ''
                });
            } catch (err) {
                // console.log(err)
                // showError("Failed to load workspace");
            } finally {
                setLoading(false);
            }
        };

        fetchWorkspace();
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await axiosDotnet.put(`/api/workspaces/${id}`, {
                name: workspace.name,
                description: workspace.description
            });

            showSuccess("Workspace updated successfully!");
            navigate('/dashboard');
        } catch (err) {
            showError(err?.response?.data?.message || "Failed to update workspace");
        }
    };

    // if (loading) return <div className="p-12 text-center">Loading...</div>;

    return (<>
            {loading ? (
                <Loader text="Loading Workspace Data..." />
            ) : (
                <div className="min-h-screen bg-zinc-950 text-white p-8">
                <div className="max-w-2xl mx-auto">
                    <button
                        onClick={() => navigate('/dashboard')}
                        className="mb-6 text-violet-400 hover:text-violet-300 flex items-center gap-2"
                    >
                        ← Back to Dashboard
                    </button>
    
                    <div className="bg-zinc-900 border border-zinc-800 rounded-3xl p-10">
                        <h1 className="text-3xl font-bold mb-8">Update Workspace</h1>
    
                        <form onSubmit={handleSubmit} className="space-y-6">
                            <div>
                                <label className="block text-sm text-zinc-400 mb-2">Workspace Name</label>
                                <input
                                    type="text"
                                    value={workspace.name}
                                    onChange={(e) => setWorkspace({ ...workspace, name: e.target.value })}
                                    className="w-full bg-zinc-950 border border-zinc-700 rounded-2xl px-5 py-4 focus:border-violet-500 outline-none"
                                    required
                                />
                            </div>
    
                            <div>
                                <label className="block text-sm text-zinc-400 mb-2">Description</label>
                                <textarea
                                    value={workspace.description}
                                    onChange={(e) => setWorkspace({ ...workspace, description: e.target.value })}
                                    rows={5}
                                    className="w-full bg-zinc-950 border border-zinc-700 rounded-2xl px-5 py-4 focus:border-violet-500 outline-none resize-y"
                                />
                            </div>
    
                            <div className="flex gap-4 pt-4">
                                <button
                                    type="button"
                                    onClick={() => navigate('/dashboard')}
                                    className="flex-1 py-4 border border-zinc-700 rounded-2xl hover:bg-zinc-800"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="cursor-pointer flex-1 py-4 bg-violet-600 hover:bg-violet-500 rounded-2xl font-semibold"
                                >
                                    Update Workspace
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            )}
            </>
    );
}